"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = bindEvents;

function bindEvents(vueInst, googleMapsInst, events) {
  events.forEach(function (eventName) {
    if (vueInst.$gmapOptions.autobindAllEvents || vueInst.$listeners[eventName]) {
      googleMapsInst.addListener(eventName, function (ev) {
        vueInst.$emit(eventName, ev);
      });
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/gmap-vue/dist/utils/bind-events.js
// module id = 158
// module chunks = 1